import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

// Grommet

// Appt
import Box from '../components/simple/box/Box.js'
import Login from '../components/compound/login/Login.js'
import PasswordResetRequest from '../components/compound/login/PasswordResetRequest.js'
import Text from '../components/simple/text/Text.js'
import UserVerification from '../components/compound/login/UserVerification.js'
import Image from '../components/simple/image/Image.js'


// Services
import ApiService from '../services/ApiService'
import NotificationService from '../services/NotificationService'
import PasswordService from '../services/PasswordService'
import LocalStorageService from '../services/LocalStorageService.js'

// Stores
import { useStore } from 'react-context-hook'

// Error handler
// import useErrorHandler from '../utils/useErrorHandler'

// Theme
// import { hostTheme } from 'utilities/hostTheme'
import ActionButton from '../components/compound/actionButton/ActionButton.js'

import { CONNECTION_DEBUG, SECURITY_ENFORCE_PASSWORD_POLICY } from "../env";

function LoginScreen(props) {
  const navigate = useNavigate()

  const [loading, setLoading] = useState(false)
  const [createPassword, setCreatePassword] = useState(false)
  const [viewLogin, setLoginView] = useState(true)
  const [verificationNeeded, setVerification] = useState(false)
  const [userValues, setUserValues] = useState()

  const [error, setError] = useState(null)

  const [apiToken, setApiToken, deleteApiToken] = useStore(null)
  const [currentUser, setCurrentUser, deleteCurrentUser] = useStore({})
  const [currentOrgs, setCurrentOrgs, deleteCurrentOrgs] = useStore([])

  // const { error, showError } = useErrorHandler(null)

  const signInClicked = async (values) => {
    setUserValues(values)

    let rememberMe = LocalStorageService.get("rememberMe");
    let rememberMeCode = LocalStorageService.get("rememberMeCode");
    let rememberMeExpiry = LocalStorageService.get("rememberMeExpiry");
    if (rememberMe && rememberMeCode && rememberMeExpiry) {
      const now = new Date();
      const expiryDate = new Date(rememberMeExpiry);

      // still valid
      if (now < expiryDate) {

        const loginStatus = await ApiService.verifyAccount(values.username, values.password, rememberMeCode, true)

        // stop if the login failed
        if (loginStatus.error || loginStatus?.data?.verificationNeeded) {
          // clear the remember me details
          LocalStorageService.remove("rememberMe");
          LocalStorageService.remove('rememberMeCode');
          LocalStorageService.remove('rememberMeExpiry');

          // continue with normal login

        } else {
          // if you're here, you're logged in
          props.handleLogin(loginStatus.data)
          // if you're here, you're logged in
          navigate('/dashboard')
          return
        }
      }
      rememberMe = false;
    }



    var loginStatus = await ApiService.login(values.username, values.password)

    // stop if the login failed
    if (loginStatus.error) {
      NotificationService.error(loginStatus.error)
    } else {
      // the password is valid but the length is insufficient
      // force a password reset
      if (SECURITY_ENFORCE_PASSWORD_POLICY === 'true' && values.password?.length < 10) {
        // NotificationService.error('Password must be at least 10 characters long. Reset your password to continue')
        setError('Password must be at least 10 characters long. A password reset has been initiated. Please check your inbox to continue.')
        await resetPasswordClicked({ email: values.username })
        return
      }

      if (loginStatus.data?.verificationNeeded) {
        setVerification(true)
        // navigate('/user/verification', { username: values.username, password: values.password })
      } else {
        props.handleLogin(loginStatus.data)

        // if you're here, you're logged in
        navigate('/dashboard')
      }
    }
  }

  const signup = () => {
    // window.open('https://www.behavioursmart.co.uk/new-signup-page', '_blank')
    navigate('/get-started')
  }


  const resetPasswordClicked = async (values) => {
    // organisationId not needed for a reset password from the login screen
    const organisationId = 50
    try {
      var passwordResetStatus = await PasswordService.resetPasswordRequest(organisationId, values.email)
    } catch (err) {
      NotificationService.error(err)
    }

    NotificationService.info('A password reset has been requested. Please check your inbox.')
    setLoginView(true)
  }

  const handleVerificationCode = async (code, rememberMe = false) => {
    const loginStatus = await ApiService.verifyAccount(userValues.username, userValues.password, code, rememberMe)

    // stop if the login failed
    if (loginStatus.error) {
      NotificationService.error(loginStatus.error)
    } else {
      // if you're here, you're logged in
      props.handleLogin(loginStatus.data)
      navigate('/dashboard')
    }
  }

  const viewLoginScreen = () => {
    setLoginView(true)
  }

  const viewPasswordForgotScreen = () => {
    setLoginView(false)
  }

  // Login screen parameters
  const title = {
    label: 'Login',
    position: 'start'
  }

  const username = {
    label: 'Email',
    position: 'above'
  }

  const password = {
    label: 'Password',
    position: 'above'
  }

  const submit = {
    label: 'Next',
    size: 'small',
    position: 'end'
  }

  const forgotPassword = {
    label: 'Forgotten your password?',
    position: 'start'
  }

  return (
    <>

      <Box align='center' height='100%' justify='center' alignSelf='center'>
        <Box width='small' alignSelf='center' height='xsmall' margin={{ bottom: 'medium' }}>
          <Image fit='contain' src='/besmart-logo-white.png?r=001' />
        </Box>
        {CONNECTION_DEBUG === 'true' && <>
          <Text color='white'>Server: {ApiService._getServerRoot()}</Text>
        </>}

        <Box border={{ color: 'brand', side: 'top' }}>
          {viewLogin && !verificationNeeded &&
            <>
              <Box pad={{ vertical: 'medium' }} width='medium'>
                {error?.length > 0 && <Box width='medium' height='xsmall' align='center' margin={{ bottom: 'small' }} pad='small' background='primary' round='small'>
                  <Text color='secondary' size='medium' weight='bold'>{error}</Text>
                </Box>}
                <Login forgotPassword={forgotPassword} labelColor='#ffffff' onForgotPasswordClick={viewPasswordForgotScreen} triggerPasswordReset={resetPasswordClicked} onSignInClick={signInClicked} password={password} submit={submit} title={title} username={username} />
              </Box>

              <Box width='medium'>
                <Text color='white' weight='bold' size='medium' margin={{ bottom: 'xsmall' }}>Don't have a service account?</Text>
                <ActionButton onClick={() => signup()} secondary><Text color='primary' weight='bold' size='medium' margin={{ bottom: 'xsmall' }}>Sign up for Behaviour Smart here.</Text></ActionButton>
              </Box>
            </>
          }
          {!viewLogin && !verificationNeeded &&
            <Box fill justify='center' pad={{ vertical: 'medium' }} border={{ color: 'brand', side: 'bottom' }}>
              <PasswordResetRequest labelColor='#ffffff' onBackClick={viewLoginScreen} onResetPasswordClick={resetPasswordClicked} />
            </Box>}
          { verificationNeeded &&
            <Box fill justify='center' pad={{ vertical: 'medium' }} border={{ color: 'brand', side: 'bottom' }}>
              <UserVerification labelColor='#ffffff' onBackClick={viewLoginScreen} handleVerificationCode={handleVerificationCode} />
            </Box>}
        </Box>
      </Box>

    </>
  )
}

export default LoginScreen
